import { BaseEntity, Transform, toDate, toEntity } from './base';
import { NoteModel } from './note';

export class OpsVehicleModel extends BaseEntity {
  year?: number;
  color?: string;
  serialNumber?: string;
  vin?: string;
  license?: string;
  recommendedPsiFront?: number;
  recommendedPsiRear?: number;
  requestedPsiFront?: number;
  requestedPsiRear?: number;
  geolocation: VehicleGeolocation;
  vehicleMake?: Make;
  vehicleModel?: Model;

  @Transform(toDate)
  lastCarWashCompletedAt: Date;

  @Transform(toDate)
  lastOilChangeCompletedAt: Date;

  @Transform(toDate)
  psiLastCheck?: Date;

  @Transform(toEntity(NoteModel))
  notes: NoteModel[];

  get infoComplete() {
    return this.license && this.license.length > 0;
  }
}

export interface VehicleGeolocation {
  lat: number;
  lng: number;
  createdAt: Date;
}

export interface Make {
  id: number;
  uid: string;
  make: string;
}

export interface FuelLevel {
  level?: number;
  createdAt?: Date;
}

export interface Model {
  id: number;
  uid: string;
  model: string;
}

export interface VehicleParams {
  vehicleModelUid?: string;
  color?: string;
  nickname?: string;
  license?: string;
  fuelGaugeThreshold?: number;
  year?: number;
  requestedPsiFront?: number;
  requestedPsiRear?: number;
}

export interface VehicleFillerUpdateParams {
  color?: string;
  license?: string;
}
export interface VehicleGeolocation {
  lat: number;
  lng: number;
  createdAt: Date;
}



// WEBPACK FOOTER //
// ./src/models/vehicle.ops.ts